import { z } from "zod";

export const SellerLeadInput = z.object({
  address: z.string().min(5).max(300),
  city: z.string().min(2).max(120).optional(),
  property_type: z.enum(["appartamento", "villa", "attico", "rustico", "terreno", "commerciale", "altro"]),
  mq: z.number().positive().max(10000).optional(),
  rooms: z.number().int().min(0).max(40).optional(),
  bathrooms: z.number().int().min(0).max(20).optional(),
  energy_class: z.string().max(4).optional(),
  year_built: z.number().int().min(1700).max(2050).optional(),
  photo_urls: z.array(z.string().url()).max(20).optional(),
  contact_name: z.string().min(2).max(120),
  contact_email: z.string().email(),
  contact_phone: z.string().max(40).optional(),
  notes: z.string().max(4000).optional(),
  consents: z.object({
    privacy: z.literal(true),
    marketing: z.boolean().default(false),
  }),
  turnstile_token: z.string().min(10),
});
export type SellerLeadInput = z.infer<typeof SellerLeadInput>;
